export default {
    getGamerData(state) {
        return state.selectedGamerData;
      },
    getSelectedGamer(state){
      return state.selectedGamer;
    },
    getMySalary(state){
      return state.mySalary;
    }
}